import { useEffect } from "react"
import { Grid } from "../components"
import { Navbar, Footer } from "../layouts"
import BankvoleFrequentQuestion from "../components/bankvole-frequent-question"




const BankVoleFAQs = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/>
        <BankvoleFrequentQuestion/>
        <Footer/>
        </>

    )
}

export default BankVoleFAQs